import React from 'react';
import { FormData, FormErrors, OrderType } from '../../hooks/useCheckoutForm';
import { PickupForm } from './PickupForm';
import { DeliveryForm } from './DeliveryForm';

interface CheckoutFormProps {
  formData: FormData;
  errors: FormErrors;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
  onTakeoutOrder: () => void;
  onDeliveryQuote: () => void;
  orderLoading: boolean;
  submittingMethod: 'takeout' | 'pay_online' | 'delivery' | null;
  cartItemsCount: number;
  showPayNow?: boolean;
  showPayLater?: boolean;
  activeTab: OrderType;
}

export const CheckoutForm: React.FC<CheckoutFormProps> = ({
  formData,
  errors,
  handleChange,
  onSubmit,
  onTakeoutOrder,
  onDeliveryQuote,
  orderLoading,
  submittingMethod,
  cartItemsCount,
  showPayNow = true,
  showPayLater = true,
  activeTab,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      {/* Conditional Form Rendering */}
      {activeTab === 'pickup' ? (
        <PickupForm
          formData={formData}
          errors={errors}
          handleChange={handleChange}
          onSubmit={onSubmit}
          onTakeoutOrder={onTakeoutOrder}
          orderLoading={orderLoading}
          submittingMethod={submittingMethod}
          cartItemsCount={cartItemsCount}
          showPayNow={showPayNow}
          showPayLater={showPayLater}
        />
      ) : (
        <DeliveryForm
          formData={formData}
          errors={errors}
          handleChange={handleChange}
          onDeliveryQuote={onDeliveryQuote}
          orderLoading={orderLoading}
          submittingMethod={submittingMethod}
          cartItemsCount={cartItemsCount}
        />
      )}
    </div>
  );
};
